<template>
	<a-result status="404" title="404" sub-title="页面未找到" style="margin-top: 3.125rem;">
		<template #extra>
			<a-button type="primary" icon="home" @click="goHome">
				回到首页
			</a-button>
		</template>
	  </a-result>
</template>
<script>
	export default{
		data(){
			return{}
		},
		methods:{
			goHome:function(){
				this.Config.goHome();
			},
		}
	}
</script>
<style scoped="scoped">
	#main{
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
